/**
 * Collection Sort Handler
 * Global function to handle collection sorting
 */

// Define global sort handler
if (typeof window.handleSortChange === "undefined") {
  window.handleSortChange = function (sortValue) {
    try {
      // Method 1: Try Shopify.queryParams (preferred)
      if (typeof Shopify !== "undefined" && Shopify.queryParams) {
        Shopify.queryParams.sort_by = sortValue;

        // Try jQuery param if available
        if (typeof jQuery !== "undefined" && jQuery.param) {
          location.search = jQuery.param(Shopify.queryParams);
        } else {
          // Fallback: Native URLSearchParams
          var params = new URLSearchParams();
          for (var key in Shopify.queryParams) {
            params.set(key, Shopify.queryParams[key]);
          }
          location.search = params.toString();
        }
      } else {
        // Method 2: Manual URL construction
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortValue);
        window.location.href = url.toString();
      }
    } catch (error) {
      // Ultimate fallback: Simple reload with query param
      window.location.href = window.location.pathname + "?sort_by=" + sortValue;
    }
  };

  // Auto-apply default sort on collection pages without sort parameter
  // This ensures consistent product order between initial load and "Featured" selection
  if (
    window.location.pathname.includes("/collections/") &&
    !window.location.search.includes("sort_by")
  ) {
    // Only on collection pages without existing sort parameter
    var urlParams = new URLSearchParams(window.location.search);

    // Don't redirect if other filters/parameters exist (except pagination)
    var hasOtherParams = false;
    for (var pair of urlParams.entries()) {
      if (pair[0] !== "page") {
        hasOtherParams = true;
        break;
      }
    }

    // Apply default sort
    if (
      !hasOtherParams ||
      urlParams.toString() === "" ||
      urlParams.get("page")
    ) {
      urlParams.set("sort_by", "manual");

      // Preserve existing parameters
      var newSearch = urlParams.toString();
      if (window.location.search.substring(1) !== newSearch) {
        window.location.search = newSearch;
      }
    }
  }
}

/**
 * Sort Dropdown Toggle & Click Outside Handler
 */
(function () {
  "use strict";

  function initSortDropdown() {
    var sortDropdown = document.querySelector(".collection-sort-dropdown");
    var sortTrigger = document.querySelector(
      ".collection-sort-dropdown .sort-trigger"
    );

    if (!sortDropdown || !sortTrigger) return;

    // Toggle dropdown on trigger click
    sortTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      sortDropdown.classList.toggle("is-open");
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!sortDropdown.contains(e.target)) {
        sortDropdown.classList.remove("is-open");
      }
    });

    // Prevent clicks inside dropdown from closing it (except on sort option links)
    sortDropdown.addEventListener("click", function (e) {
      // If clicking on a sort option link, allow it to proceed (will trigger handleSortChange)
      if (e.target.tagName === "A" && e.target.closest(".sort-options")) {
        // Let the link handle the sorting
        return;
      }
      // Otherwise, prevent event from bubbling to document
      e.stopPropagation();
    });

    // Close dropdown on ESC key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sortDropdown.classList.contains("is-open")) {
        sortDropdown.classList.remove("is-open");
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSortDropdown);
  } else {
    initSortDropdown();
  }
})();
